module.exports = __webpack_public_path__ + "img/step_5.085dd4d1.png";